import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CustomerMasterPageComponent } from './customer-master-page.component';

const routes: Routes = [
  {
    path: 'customer-master',
    data: { name: 'Customer Master', isTab: false },
    component: CustomerMasterPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerMasterPageRoutingModule {}
